export enum InstallmentsFeeResponsible {
  MERCHANT = 'merchant',
  CUSTOMER = 'customer',
}
